module.exports = __webpack_public_path__ + "static/gtm_1-3e05076d9a42ad30dc4a29eefbec11c0.png";